export enum SpecialUsersIds {
  system = '00000000-0000-0000-0000-000000000000',
}

export enum UserState {
  Invited = 'Invited',
  Active = 'Active',
  Created = 'Created',
  Disabled = 'Disabled',
}

export enum SelectableUserTag {
  partner = 'Partner',
  lawFirm = 'Law firm',
  marketing = 'Marketing agency',
  interesting = 'Interesting client',
  extraChecksPurchased = 'Extra checks purchased',
  specialCircumstances = 'Special circumstances',
  adaLin = 'Ada Lin',
}

export enum AutomaticUserTag {
  loyalCustomer = 'Loyal customer',
  excessiveUse = 'Excessive use',
}

export const UserTag = {
  ...SelectableUserTag,
  ...AutomaticUserTag,
}
export type UserTag = SelectableUserTag | AutomaticUserTag

export const userTagOmittanceRules: Partial<Record<UserTag, UserTag[]>> = {
  [UserTag.loyalCustomer]: [AutomaticUserTag.excessiveUse],
  [UserTag.extraChecksPurchased]: [AutomaticUserTag.excessiveUse],
}

export enum UserIndustry {
  entertainment = 'Entertainment',
  tech = 'Tech',
  cosmetics = 'Cosmetics',
  clothingAccessories = 'Clothing/Accessories',
  pharmaceutical = 'Pharmaceutical',
  finance = 'Finance',
}

export enum UserAction {
  passwordResetRequested = 'Password reset requested',
  passwordReset = 'Password reset',
  passwordChanged = 'Password changed',
  welcomeEmailSent = 'Welcome email sent',
}

export enum UserTrackingActionId {}

export enum AuthActionType {
  signUp = 'sign-up',
  signIn = 'sign-in',
  activate = 'activate',
}

export const isAuthActionType = (value: string | null | undefined): value is AuthActionType =>
  Object.values(AuthActionType).includes(value as AuthActionType)

export enum AuthPageType {
  general = 'general',
  sensitiveData = 'sensitive-data',
}

export const userAlreadyExistsErrorMessage = 'User already exists'

export const USER_SECRET_TTL_MINUTES = 15
